import { useState, useEffect } from 'react';
import { tenant as tenantApi } from '../services/api';
import { PlanRequerido } from '../services/permisos';

export default function Tokens({ permisos, onUpgrade }) {
  const [tokens,        setTokens]        = useState(null);
  const [loading,       setLoading]       = useState(true);
  const [whisper,       setWhisper]       = useState(null);
  const [whisperActivo, setWhisperActivo] = useState(true);
  const [detalle,       setDetalle]       = useState(null);
  const [historico,     setHistorico]     = useState([]);

  useEffect(() => {
    // ✅ allSettled: si un endpoint da 404 los demás siguen funcionando
    Promise.allSettled([
      tenantApi.getTokenUsage(),
      tenantApi.getWhisperUsage(),
      tenantApi.getMe(),
      tenantApi.getTokensDetalle(),
    ]).then(([tok, wh, me, det]) => {
      if (tok.status === 'fulfilled') setTokens(tok.value);
      if (wh.status  === 'fulfilled') setWhisper(wh.value);
      if (me.status  === 'fulfilled') setWhisperActivo(me.value.whisper_activo !== false);
      // Solo guardamos detalle si tiene la estructura esperada
      if (det.status === 'fulfilled' && det.value?.canales) setDetalle(det.value);
      setLoading(false);
    });
  }, []);

  const handleToggleWhisper = async () => {
    const res = await tenantApi.toggleWhisper();
    setWhisperActivo(res.whisper_activo);
  };

  if (!permisos?.tokens) return <PlanRequerido onUpgrade={onUpgrade} />;
  if (loading) return <div className="content" style={{ color: 'var(--text3)' }}>Cargando...</div>;

  const pct           = tokens?.mes_actual?.porcentaje   || 0;
  const usados        = tokens?.mes_actual?.tokens_usados || 0;
  const circumference = 2 * Math.PI * 42;
  const offset        = circumference - (pct / 100) * circumference;

  return (
    <div>
      <div className="topbar">
        <div>
          <div className="page-title">Tokens Groq</div>
          <div className="page-sub">Monitoreo de consumo</div>
        </div>
      </div>

      <div className="content">
        {pct > 80 && (
          <div className="alert alert-warn">
            <span className="alert-icon">⚠️</span>
            Llevas el {pct}% del plan. Si superas 100k tokens este mes se aplicará un cargo extra.
          </div>
        )}

        {/* ── Whisper ────────────────────────────────────────── */}
        <div className="card" style={{ marginTop: '16px' }}>
          <div className="section-header">
            <div className="section-title">Whisper — Reconocimiento de voz</div>
            <label className="toggle">
              <input type="checkbox" checked={whisperActivo} onChange={handleToggleWhisper} />
              <span className="slider-toggle"></span>
            </label>
          </div>
          <div style={{ fontSize: '12px', color: 'var(--text2)', marginBottom: '16px' }}>
            {whisperActivo
              ? 'Activo — tu agente entiende mensajes de voz en WhatsApp'
              : 'Inactivo — los audios no serán procesados'}
          </div>

          {whisper && (
            <div className="two-col">
              <div style={{ background: 'var(--bg3)', borderRadius: '8px', padding: '14px', border: '1px solid var(--border)' }}>
                <div style={{ fontSize: '10px', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Este mes</div>
                <div style={{ fontSize: '24px', fontWeight: 700, color: 'var(--cyan)' }}>{whisper.mes_actual.minutos}min</div>
                <div style={{ fontSize: '11px', color: 'var(--text3)', marginTop: '4px' }}>{whisper.mes_actual.audios || 0} audios procesados</div>
                <div style={{ fontSize: '11px', color: 'var(--text3)', marginTop: '2px' }}>€{whisper.mes_actual.coste_eur} coste</div>
              </div>
              <div style={{ background: 'var(--bg3)', borderRadius: '8px', padding: '14px', border: '1px solid var(--border)' }}>
                <div style={{ fontSize: '10px', color: 'var(--text3)', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Últimos 7 días</div>
                {whisper.ultimos_7_dias.length > 0 ? (
                  <table className="mini-table">
                    {whisper.ultimos_7_dias.map((d, i) => (
                      <tr key={i}>
                        <td style={{ color: 'var(--text3)' }}>{d.dia}</td>
                        <td style={{ textAlign: 'right', color: 'var(--text)' }}>{d.audios} audios</td>
                        <td style={{ textAlign: 'right', color: 'var(--cyan)' }}>{Math.round(d.segundos)}s</td>
                      </tr>
                    ))}
                  </table>
                ) : (
                  <div style={{ fontSize: '11px', color: 'var(--text3)' }}>Sin audios aún</div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* ── Ring total + desglose diario ───────────────────── */}
        <div className="two-col" style={{ marginBottom: '20px' }}>
          <div className="card" style={{ textAlign: 'center' }}>
            <div className="card-title" style={{ textAlign: 'left' }}>Tokens usados este mes</div>
            <div className="ring-val">{Math.round(usados / 1000)}k</div>
            <div className="ring-label">de {(tokens?.tokens_limite || 5000000).toLocaleString()} incluidos</div>
            <div style={{ marginTop: '12px', display: 'flex', justifyContent: 'center' }}>
              <svg width="100" height="100" viewBox="0 0 100 100" className="ring">
                <circle cx="50" cy="50" r="42" fill="none" stroke="var(--bg4)" strokeWidth="8" />
                <circle cx="50" cy="50" r="42" fill="none"
                  stroke={pct > 80 ? 'var(--amber)' : 'var(--green)'}
                  strokeWidth="8"
                  strokeDasharray={circumference}
                  strokeDashoffset={offset}
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <div style={{ marginTop: '8px', fontSize: '12px', color: 'var(--text3)' }}>
              {pct.toFixed(1)}% utilizado
            </div>
          </div>

          <div className="card">
            <div className="card-title">Desglose por día (últimos 7 días)</div>
            {tokens?.ultimos_7_dias?.length > 0 ? (
              <table className="mini-table">
                {tokens.ultimos_7_dias.map((d, i) => {
                  const badge = d.tokens > 15000
                    ? <span className="badge badge-amber">alto</span>
                    : <span className="badge badge-green">ok</span>;
                  return (
                    <tr key={i}>
                      <td style={{ color: 'var(--text3)' }}>{d.dia}</td>
                      <td style={{ textAlign: 'right', color: 'var(--text)' }}>{d.tokens.toLocaleString()}</td>
                      <td style={{ textAlign: 'right' }}>{badge}</td>
                    </tr>
                  );
                })}
              </table>
            ) : (
              <div style={{ color: 'var(--text3)', fontSize: '11px', marginTop: '8px' }}>
                Sin datos aún. Envía mensajes al agente para ver el consumo.
              </div>
            )}
          </div>
        </div>

        {/* ── DESGLOSE POR CANAL/ORIGEN — solo si el endpoint ya responde */}
        {detalle && <TokenDesglose detalle={detalle} />}

        {/* ── Alertas de consumo ─────────────────────────────── */}
        <div className="card">
          <div className="section-header">
            <div className="section-title">Alertas de consumo</div>
          </div>
          <div className="toggle-wrap">
            <div className="toggle-info">
              <div className="toggle-name">Alerta al 80%</div>
              <div className="toggle-desc">Aviso cuando alcances 80,000 tokens</div>
            </div>
            <label className="toggle">
              <input type="checkbox" defaultChecked />
              <span className="slider-toggle"></span>
            </label>
          </div>
          <div className="toggle-wrap">
            <div className="toggle-info">
              <div className="toggle-name">Alerta al 100%</div>
              <div className="toggle-desc">Aviso cuando se agote el plan</div>
            </div>
            <label className="toggle">
              <input type="checkbox" defaultChecked />
              <span className="slider-toggle"></span>
            </label>
          </div>
          <div className="toggle-wrap">
            <div className="toggle-info">
              <div className="toggle-name">Límite duro</div>
              <div className="toggle-desc">Pausar el agente si se superan 110k tokens</div>
            </div>
            <label className="toggle">
              <input type="checkbox" />
              <span className="slider-toggle"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}


// ─────────────────────────────────────────────
// Componente de desglose por canal
// ─────────────────────────────────────────────

function TokenDesglose({ detalle }) {
  // ✅ Usamos 'd' consistentemente — nunca accedemos a 'detalle' directamente
  const d = {
    total_global:   detalle?.total_global   || 0,
    total_chats:    detalle?.total_chats    || 0,
    total_contenido:detalle?.total_contenido|| 0,
    canales:        detalle?.canales        || [],
    contenido:      detalle?.contenido      || [],
  };

  const total = d.total_global || 1; // evitar división por cero

  return (
    <div className="card" style={{ marginBottom: '20px' }}>
      <div className="section-header" style={{ marginBottom: '16px' }}>
        <div className="section-title">Consumo por canal este mes</div>
      </div>

      {/* ── CHATS ──────────────────────────────── */}
      <div style={{ marginBottom: '20px' }}>
        <div style={{
          fontSize: '10px', color: 'var(--text3)', textTransform: 'uppercase',
          letterSpacing: '1px', marginBottom: '10px', display: 'flex',
          alignItems: 'center', gap: '6px'
        }}>
          <span>💬</span> Chats —
          <span style={{ color: 'var(--text)', fontWeight: 600 }}>
            {d.total_chats.toLocaleString()} tok
          </span>
        </div>

        {d.canales.map((canal) => (
          <CanalBar
            key={canal.source}
            icono={canal.icono}
            label={canal.label}
            tokens={canal.tokens}
            total={total}
            color="var(--cyan)"
          />
        ))}
      </div>

      {/* Divisor */}
      <div style={{ borderTop: '1px solid var(--border)', marginBottom: '20px' }} />

      {/* ── GENERADOR DE CONTENIDO ─────────────── */}
      <div>
        <div style={{
          fontSize: '10px', color: 'var(--text3)', textTransform: 'uppercase',
          letterSpacing: '1px', marginBottom: '10px', display: 'flex',
          alignItems: 'center', gap: '6px'
        }}>
          <span>✍️</span> Generador de contenido —
          <span style={{ color: 'var(--text)', fontWeight: 600 }}>
            {d.total_contenido.toLocaleString()} tok
          </span>
        </div>

        {d.contenido.map((item) => (
          <CanalBar
            key={item.source}
            icono={item.icono}
            label={item.label}
            tokens={item.tokens}
            total={total}
            color="#a78bfa"
          />
        ))}
      </div>

      {/* ── Total global ───────────────────────── */}
      <div style={{
        borderTop: '1px solid var(--border)', marginTop: '16px', paddingTop: '12px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <span style={{ fontSize: '12px', color: 'var(--text3)' }}>Total global este mes</span>
        <span style={{ fontSize: '16px', fontWeight: 700, color: 'var(--text)' }}>
          {d.total_global.toLocaleString()} tok
        </span>
      </div>
    </div>
  );
}

function HistoricoMeses({ historico }) {
  if (!historico || historico.length === 0) return null;

  const LIMITE = 100000;
  

  // Agrupar por mes sumando todos los sources
  const porMes = {};
  historico.forEach(r => {
    const key = r.mes; // "2025-01-01"
    if (!porMes[key]) porMes[key] = { mes: r.mes, total: 0, detalle: {} };
    porMes[key].total += r.tokens_total;
    porMes[key].detalle[r.source] = (porMes[key].detalle[r.source] || 0) + r.tokens_total;
  });

  const meses = Object.values(porMes).sort((a, b) => b.mes.localeCompare(a.mes)).slice(0, 6);
  const maxTokens = Math.max(...meses.map(m => m.total), LIMITE);

  const formatMes = (str) => {
    const d = new Date(str + 'T00:00:00');
    return d.toLocaleDateString('es-ES', { month: 'short', year: '2-digit' });
  };

  return (
    <div className="card" style={{ marginBottom: '20px' }}>
      <div className="section-header" style={{ marginBottom: '20px' }}>
        <div className="section-title">Histórico mensual</div>
        <span style={{ fontSize: '11px', color: 'var(--text3)' }}>Últimos 6 meses</span>
      </div>

      {/* Gráfica de barras */}
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', height: '100px', marginBottom: '8px' }}>
        {meses.map((m, i) => {
          const altura = Math.max(4, (m.total / maxTokens) * 100);
          const sobrepaso = m.total > LIMITE;
          const pct = Math.round((m.total / LIMITE) * 100);

          return (
            <div key={m.mes} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
              {/* Barra */}
              <div style={{ position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '80px' }}>
                {/* Línea de límite */}
                {i === 0 && (
                  <div style={{
                    position: 'absolute',
                    top: `${100 - (LIMITE / maxTokens) * 100}%`,
                    left: '-4px', right: '-4px',
                    borderTop: '1px dashed rgba(255,180,0,0.4)',
                    zIndex: 2
                  }} />
                )}
                <div style={{
                  width: '100%',
                  height: `${altura}%`,
                  background: sobrepaso
                    ? 'linear-gradient(to top, var(--amber, #f59e0b), rgba(245,158,11,0.5))'
                    : i === 0
                      ? 'linear-gradient(to top, var(--cyan), rgba(0,229,160,0.3))'
                      : 'var(--bg4)',
                  borderRadius: '4px 4px 0 0',
                  transition: 'height 0.5s ease',
                  cursor: 'default',
                  position: 'relative'
                }} title={`${m.total.toLocaleString()} tokens (${pct}%)`} />
              </div>
              {/* Etiqueta mes */}
              <div style={{ fontSize: '9px', color: i === 0 ? 'var(--cyan)' : 'var(--text3)', fontFamily: 'var(--font-mono)', textAlign: 'center' }}>
                {formatMes(m.mes)}
              </div>
            </div>
          );
        })}
      </div>

      {/* Leyenda del límite */}
      <div style={{ fontSize: '10px', color: 'var(--text3)', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{ borderTop: '1px dashed rgba(255,180,0,0.5)', display: 'inline-block', width: '16px' }} />
        Límite de tokens incluidos en el plan
      </div>
      

      {/* Tabla detalle */}
      <table className="mini-table" style={{ width: '100%' }}>
        <thead>
          <tr>
            <td style={{ color: 'var(--text3)', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px' }}>Mes</td>
            <td style={{ color: 'var(--text3)', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'right' }}>Tokens</td>
            <td style={{ color: 'var(--text3)', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'right' }}>Uso</td>
            <td style={{ color: 'var(--text3)', fontSize: '10px', textTransform: 'uppercase', letterSpacing: '1px', textAlign: 'right' }}>Estado</td>
          </tr>
        </thead>
        <tbody>
          {meses.map((m, i) => {
            const pct = Math.round((m.total / LIMITE) * 100);
            const sobrepaso = m.total > LIMITE;
            const extra = sobrepaso ? m.total - LIMITE : 0;

            return (
              <tr key={m.mes}>
                <td style={{ color: i === 0 ? 'var(--cyan)' : 'var(--text2)', fontWeight: i === 0 ? 600 : 400 }}>
                  {new Date(m.mes + 'T00:00:00').toLocaleDateString('es-ES', { month: 'long', year: 'numeric' })}
                  {i === 0 && <span style={{ fontSize: '9px', color: 'var(--text3)', marginLeft: '6px' }}>(actual)</span>}
                </td>
                <td style={{ textAlign: 'right', fontVariantNumeric: 'tabular-nums', color: 'var(--text)' }}>
                  {m.total.toLocaleString()}
                </td>
                <td style={{ textAlign: 'right', color: sobrepaso ? 'var(--amber, #f59e0b)' : 'var(--text3)', fontVariantNumeric: 'tabular-nums' }}>
                  {pct}%
                </td>
                <td style={{ textAlign: 'right' }}>
                  {sobrepaso
                    ? <span className="badge badge-amber">+{extra.toLocaleString()} extra</span>
                    : pct > 80
                      ? <span className="badge badge-amber">alto</span>
                      : <span className="badge badge-green">ok</span>
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}



// ─────────────────────────────────────────────
// Barra de un canal
// ─────────────────────────────────────────────

function CanalBar({ icono, label, tokens, total, color }) {
  const pct = total > 0 ? Math.min(100, (tokens / total) * 100) : 0;

  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3px' }}>
        <span style={{ fontSize: '12px', color: 'var(--text2)', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span>{icono}</span>
          {label}
        </span>
        <span style={{ fontSize: '12px', color: tokens > 0 ? 'var(--text)' : 'var(--text3)', fontVariantNumeric: 'tabular-nums' }}>
          {tokens > 0 ? tokens.toLocaleString() : '—'}
          {tokens > 0 && (
            <span style={{ color: 'var(--text3)', marginLeft: '4px' }}>
              ({pct.toFixed(1)}%)
            </span>
          )}
        </span>
      </div>
      <div style={{ height: '5px', background: 'var(--bg4)', borderRadius: '3px', overflow: 'hidden' }}>
        <div style={{
          width: `${pct}%`, height: '100%',
          background: tokens > 0 ? color : 'transparent',
          borderRadius: '3px',
          transition: 'width 0.6s ease',
          opacity: tokens > 0 ? 1 : 0
        }} />
      </div>
    </div>
  );
}

function BannerReset() {
  const hoy = new Date();
  const esPrimeraSemana = hoy.getDate() <= 7;
  if (!esPrimeraSemana) return null;

  const mesAnterior = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1)
    .toLocaleDateString('es-ES', { month: 'long', year: 'numeric' });

  return (
    <div style={{
      background: 'linear-gradient(135deg, rgba(0,229,160,0.08), rgba(0,229,160,0.03))',
      border: '1px solid rgba(0,229,160,0.25)',
      borderRadius: '10px',
      padding: '14px 18px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '12px'
    }}>
      <span style={{ fontSize: '20px' }}>🔄</span>
      <div>
        <div style={{ fontSize: '13px', color: 'var(--green)', fontWeight: 600 }}>
          Contador reiniciado
        </div>
        <div style={{ fontSize: '11px', color: 'var(--text3)', marginTop: '2px' }}>
          Nuevo mes, nuevos tokens. El consumo de <strong style={{ color: 'var(--text2)' }}>{mesAnterior}</strong> quedó
          guardado en el histórico. Tienes nuevos tokens disponibles.
        </div>
      </div>
    </div>
  );
}
